import Script from 'next/script';
import NewRelic from 'components/tags/NewRelic';
import Bing from 'components/tags/Bing';
import GoogleTagManager from 'components/tags/GoogleTagManager';
import SnowPlow from 'components/tags/SnowPlow';
import Facebook from 'components/tags/Facebook';
import OpenWrap from 'components/tags/OpenWrap';
import LiveChat from 'components/tags/LiveChat';
import GoogleMaps, { InitMap } from 'components/tags/GoogleMaps';

export interface AppScriptsProps {
  enableLivechat?: boolean;
}

export default function AppScripts(props: AppScriptsProps): JSX.Element {
  return (
    <>
      <OpenWrap />
      <Script
        src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
        strategy="afterInteractive"
        key="gpt"
      />
      <Script src="//static.criteo.net/js/ld/ld.js" strategy="afterInteractive" key="criteo" />
      <GoogleMaps />
      <InitMap />
      <Script src="https://accounts.google.com/gsi/client" strategy="afterInteractive" />
      <NewRelic />
      <Bing />
      <GoogleTagManager />
      <SnowPlow />
      <Facebook />
      {props.enableLivechat && <LiveChat />}
    </>
  );
}
